"use client";

/**
 * Client wrapper around Sentry's React error boundary. Mounts in the root
 * layout so errors thrown during client render are captured with the React
 * component stack — `instrumentation-client.ts` only catches uncaught errors
 * via window.onerror, which loses that stack.
 */
import * as Sentry from "@sentry/react";
import type { ReactNode } from "react";

function Fallback() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        textAlign: "center",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <div>
        <h1 style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>
          Something went wrong
        </h1>
        <p style={{ opacity: 0.7, marginBottom: "1.5rem" }}>
          The error has been reported. Please reload the page.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: "0.5rem 1rem",
            borderRadius: "0.5rem",
            background: "#6366f1",
            color: "white",
            border: "none",
            cursor: "pointer",
          }}
        >
          Reload
        </button>
      </div>
    </div>
  );
}

export function SentryErrorBoundary({ children }: { children: ReactNode }) {
  return <Sentry.ErrorBoundary fallback={Fallback}>{children}</Sentry.ErrorBoundary>;
}
